'use client'

import { type KeenSliderHooks, type KeenSliderInstance } from 'keen-slider'
import { type MutableRefObject } from 'react'

import { useLocale } from '@src/i18n/LocaleProvider'
import { cn } from '@src/utils/tailwind'

import { type CarouselProps } from './CarouselProps'

interface CarouselDotsProps {
  dotsStyle: CarouselProps['dotsStyle']
  instanceRef: MutableRefObject<KeenSliderInstance<any, any, KeenSliderHooks> | null>
  currentSlide: number
  slides: any[]
}

export const CarouselDots = ({
  dotsStyle,
  instanceRef,
  currentSlide,
  slides,
}: CarouselDotsProps) => {
  const { t } = useLocale('carousel')

  return (
    <div
      className={cn('mt-16 flex justify-center gap-2 px-3', {
        'mt-8': dotsStyle?.position === 'Outside Slider',
        'mt-0': dotsStyle?.position === 'Inside Slider',
      })}
    >
      {slides.map((_, index) => {
        return (
          <button
            key={index}
            aria-label={t('slide-number', { number: `${index + 1}` })}
            onClick={() => {
              instanceRef.current?.moveToIdx(index)
            }}
            className="size-3 rounded-full"
            style={{
              background:
                currentSlide === index ? dotsStyle?.selectedColor : dotsStyle?.deselectedColor,
            }}
          />
        )
      })}
    </div>
  )
}
